document.addEventListener("alpine:init", () => {
  Alpine.data("postShare", () => ({
    sharePost: false,
    copied: false,
    init() {},
    copyToClipboard(url) {
      navigator.clipboard.writeText(url).then(
        () => {
          this.copied = true;
          setTimeout(() => (this.copied = false), 2000);
        },
        () => {
          /* clipboard write failed */
        }
      );
    },
  }));
});
